import { render, staticRenderFns } from "./choseCourseSchoolBasePreview.vue?vue&type=template&id=e6862312&scoped=true&"
import script from "./choseCourseSchoolBasePreview.vue?vue&type=script&lang=js&"
export * from "./choseCourseSchoolBasePreview.vue?vue&type=script&lang=js&"
import style0 from "./choseCourseSchoolBasePreview.vue?vue&type=style&index=0&id=e6862312&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6862312",
  null
  
)

export default component.exports